import React from 'react'
import Navbar2 from '../Components/Navbar/Navbar2'
import UpdateProfileForm from '../Components/UpdateProfileForm/UpdateProfileForm'
import Footer from '../Components/Footer/Footer'

function UpdatePage() {
  return (
    <div>
        <Navbar2/>
        <UpdateProfileForm/>
        <Footer/>
    </div>
  )
}

export default UpdatePage